import { getDateOperatorOptions } from '../logicHelpers'

const dateSource = () => {
  return {
    types: [
      { label: 'Date', value: 'date' },
      //{ label: 'Time', value: 'time' },
      { label: 'Week Day', value: 'weekday' },
      { label: 'Month', value: 'month' }
    ],
    inputs: [
      {
        $formkit: 'select',
        key: 'date-operator-select',
        name: 'operator',
        options: getDateOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'date' && condition.$type === 'date'
      },
      {
        $formkit: 'select',
        key: 'time-operator-select',
        name: 'operator',
        options: getDateOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'date' && condition.$type === 'time'
      },
      {
        $formkit: 'date',
        key: 'date-value-input',
        name: 'value',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'date' &&
          condition.$type === 'date' &&
          ['equals', 'after', 'before'].includes(condition.operator)
      },
      {
        $formkit: 'date',
        key: 'date-start-input',
        name: 'value',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'date' &&
          condition.$type === 'date' &&
          condition.operator === 'between'
      },
      {
        $formkit: 'content',
        content: 'and',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'date' &&
          condition.$type === 'date' &&
          condition.operator === 'between'
      },
      {
        $formkit: 'date',
        key: 'date-end-input',
        name: 'dateEnd',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'date' &&
          condition.$type === 'date' &&
          condition.operator === 'between'
      },
      {
        $formkit: 'date',
        key: 'time-value-input',
        name: 'value',
        timeOnly: true,
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'date' &&
          condition.$type === 'time' &&
          ['equals', 'after', 'before'].includes(condition.operator)
      },
      {
        $formkit: 'date',
        key: 'time-start-input',
        name: 'value',
        timeOnly: true,
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'date' &&
          condition.$type === 'time' &&
          condition.operator === 'between'
      },
      {
        $formkit: 'date',
        key: 'time-end-input',
        timeOnly: true,
        name: 'dateEnd',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'date' &&
          condition.$type === 'time' &&
          condition.operator === 'between'
      },
      {
        $formkit: 'select',
        key: 'weekday-includes',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'date' &&
          (condition.$type === 'weekday' || condition.$type === 'month')
      },
      {
        $formkit: 'multiselect',
        key: 'weekday-value-input',
        multiple: true,
        name: 'value',
        options: [
          { label: 'Monday', value: '1' },
          { label: 'Tuesday', value: '2' },
          { label: 'Wednesday', value: '3' },
          { label: 'Thursday', value: '4' },
          { label: 'Friday', value: '5' },
          { label: 'Saturday', value: '6' },
          { label: 'Sunday', value: '0' }
        ],
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'date' && condition.$type === 'weekday'
      },
      {
        $formkit: 'multiselect',
        key: 'month-value-input',
        multiple: true,
        name: 'value',
        options: [
          { label: 'January', value: '0' },
          { label: 'February', value: '1' },
          { label: 'March', value: '2' },
          { label: 'April', value: '3' },
          { label: 'May', value: '4' },
          { label: 'June', value: '5' },
          { label: 'July', value: '6' },
          { label: 'August', value: '7' },
          { label: 'September', value: '8' },
          { label: 'October', value: '9' },
          { label: 'November', value: '10' },
          { label: 'December', value: '11' }
        ],
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'date' && condition.$type === 'month'
      }
    ]
  }
}

export default dateSource
